import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadCommitteeMemberRole: ICommitteeMemberRoleLoadActionCreator = (committeeId, committeeMemberId) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_LOAD,
            committeeId, 
            committeeMemberId
        }
    },
    LoadCommitteeMemberRoleById: ICommitteeMemberRoleLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_LOAD_BY_ID,
            id
        }
    },
    LoadCommitteeMemberRoleByCommitteeId: ICommitteeMemberRoleLoadByCommitteeIdActionCreator = (committeeId, committeeMemberId) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_LOAD_BY_COMMITTEE_ID,
            committeeId,
            committeeMemberId
        }
    },
    LoadCommitteeMemberRolesByPersonnelId: ICommitteeMemberRolesLoadByPersonnelIdActionCreator = (personnelId) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_LOAD_BY_PERSONNEL_ID,
            personnelId
        }
    },
    LoadSuccess: ICommitteeMemberRoleLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ICommitteeMemberRoleLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveCommitteeMemberRole: ICommitteeMemberRoleSaveActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_SAVE,
            formData
        }
    },
    SaveSuccess: ICommitteeMemberRoleSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ICommitteeMemberRoleSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateCommitteeMemberRole: ICommitteeMemberRoleCreateActionCreator = (committeeId, committeeMemberId) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_CREATE,
            committeeId,
            committeeMemberId
        }
    },
    CreateSuccess: ICommitteeMemberRoleCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ICommitteeMemberRoleCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateCommitteeMemberRole: ICommitteeMemberRoleValidateActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ICommitteeMemberRoleValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ICommitteeMemberRoleValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ICommitteeMemberRoleClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ICommitteeMemberRoleFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_COMMITTEEMEMBERROLE_FILTER,
            formFilter
        }
    };



export const
    ACTION_COMMITTEEMEMBERROLE_LOAD = "ACTION_COMMITTEEMEMBERROLE_LOAD",
    ACTION_COMMITTEEMEMBERROLE_LOAD_BY_ID = "ACTION_COMMITTEEMEMBERROLE_LOAD_BY_ID",
    ACTION_COMMITTEEMEMBERROLE_LOAD_BY_COMMITTEE_ID = "ACTION_COMMITTEEMEMBERROLE_LOAD_BY_COMMITTEE_ID",
    ACTION_COMMITTEEMEMBERROLE_LOAD_BY_PERSONNEL_ID = "ACTION_COMMITTEEMEMBERROLE_LOAD_BY_PERSONNEL_ID",
    ACTION_COMMITTEEMEMBERROLE_LOAD_SUCCESS = "ACTION_COMMITTEEMEMBERROLE_LOAD_SUCCESS",
    ACTION_COMMITTEEMEMBERROLE_LOAD_FAILURE = "ACTION_COMMITTEEMEMBERROLE_LOAD_FAILURE",

    ACTION_COMMITTEEMEMBERROLE_SAVE = "ACTION_COMMITTEEMEMBERROLE_SAVE",
    ACTION_COMMITTEEMEMBERROLE_SAVE_SUCCESS = "ACTION_COMMITTEEMEMBERROLE_SAVE_SUCCESS",
    ACTION_COMMITTEEMEMBERROLE_SAVE_FAILURE = "ACTION_COMMITTEEMEMBERROLE_SAVE_FAILURE",

    ACTION_COMMITTEEMEMBERROLE_CREATE = "ACTION_COMMITTEEMEMBERROLE_CREATE",
    ACTION_COMMITTEEMEMBERROLE_CREATE_SUCCESS = "ACTION_COMMITTEEMEMBERROLE_CREATE_SUCCESS",
    ACTION_COMMITTEEMEMBERROLE_CREATE_FAILURE = "ACTION_COMMITTEEMEMBERROLE_CREATE_FAILURE",

    ACTION_COMMITTEEMEMBERROLE_VALIDATE = "ACTION_COMMITTEEMEMBERROLE_VALIDATE",
    ACTION_COMMITTEEMEMBERROLE_VALIDATE_SUCCESS = "ACTION_COMMITTEEMEMBERROLE_VALIDATE_SUCCESS",
    ACTION_COMMITTEEMEMBERROLE_VALIDATE_FAILURE = "ACTION_COMMITTEEMEMBERROLE_VALIDATE_FAILURE",

    ACTION_COMMITTEEMEMBERROLE_CLEAR = "ACTION_COMMITTEEMEMBERROLE_CLEAR",

    ACTION_COMMITTEEMEMBERROLE_FILTER = "ACTION_COMMITTEEMEMBERROLE_FILTER";

export interface ICommitteeMemberRoleLoadAction {
    type: "ACTION_COMMITTEEMEMBERROLE_LOAD";
    committeeId: number;
    committeeMemberId: number;
}

export interface ICommitteeMemberRoleLoadActionCreator {
    (committeeId: number, committeeMemberId: number): ICommitteeMemberRoleLoadAction;
}

export interface ICommitteeMemberRoleLoadSuccessAction {
    type: "ACTION_COMMITTEEMEMBERROLE_LOAD_SUCCESS";
    formData: Dtos.CommitteeMemberRole | Dtos.CommitteeMemberRole[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberRoleLoadSuccessActionCreator {
    (
        formData: Dtos.CommitteeMemberRole | Dtos.CommitteeMemberRole[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMemberRoleLoadSuccessAction;
}

export interface ICommitteeMemberRoleLoadFailureAction {
    type: "ACTION_COMMITTEEMEMBERROLE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberRoleLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberRoleLoadFailureAction;
}

export interface ICommitteeMemberRoleLoadByIdAction {
    type: "ACTION_COMMITTEEMEMBERROLE_LOAD_BY_ID";
    id: number;
}

export interface ICommitteeMemberRoleLoadByIdActionCreator {
    (id: number): ICommitteeMemberRoleLoadByIdAction;
}

export interface ICommitteeMemberRoleLoadByCommitteeIdAction {
    type: "ACTION_COMMITTEEMEMBERROLE_LOAD_BY_COMMITTEE_ID";
    committeeId: number;
    committeeMemberId: number;
}

export interface ICommitteeMemberRoleLoadByCommitteeIdActionCreator {
    (committeeId: number, committeeMemberId: number): ICommitteeMemberRoleLoadByCommitteeIdAction;
}

export interface ICommitteeMemberRolesLoadByPersonnelIdAction {
    type: "ACTION_COMMITTEEMEMBERROLE_LOAD_BY_PERSONNEL_ID";
    personnelId: number;
}

export interface ICommitteeMemberRolesLoadByPersonnelIdActionCreator {
    (personnelId: number): ICommitteeMemberRolesLoadByPersonnelIdAction;
}

export interface ICommitteeMemberRoleSaveAction {
    type: "ACTION_COMMITTEEMEMBERROLE_SAVE";
    formData: Dtos.CommitteeMemberRole;

}

export interface ICommitteeMemberRoleSaveActionCreator {
    (
        formData: Dtos.CommitteeMemberRole
    ): ICommitteeMemberRoleSaveAction;
}

export interface ICommitteeMemberRoleSaveSuccessAction {
    type: "ACTION_COMMITTEEMEMBERROLE_SAVE_SUCCESS";
    formData: Dtos.CommitteeMemberRole;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberRoleSaveSuccessActionCreator {
    (
        formData: Dtos.CommitteeMemberRole,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMemberRoleSaveSuccessAction;
}

export interface ICommitteeMemberRoleSaveFailureAction {
    type: "ACTION_COMMITTEEMEMBERROLE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMemberRoleSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberRoleSaveFailureAction;
}

export interface ICommitteeMemberRoleCreateAction {
    type: "ACTION_COMMITTEEMEMBERROLE_CREATE";
    committeeId: number;
    committeeMemberId: number;
}

export interface ICommitteeMemberRoleCreateActionCreator {
    (committeeId: number, committeeMemberId: number): ICommitteeMemberRoleCreateAction
}

export interface ICommitteeMemberRoleCreateSuccessAction {
    type: "ACTION_COMMITTEEMEMBERROLE_CREATE_SUCCESS";
    formData: Dtos.CommitteeMemberRole;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ICommitteeMemberRoleCreateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMemberRole,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ICommitteeMemberRoleCreateSuccessAction;
}

export interface ICommitteeMemberRoleCreateFailureAction {
    type: "ACTION_COMMITTEEMEMBERROLE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMemberRoleCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberRoleCreateFailureAction;
}

export interface ICommitteeMemberRoleValidateAction {
    type: "ACTION_COMMITTEEMEMBERROLE_VALIDATE";
    formData: Dtos.CommitteeMemberRole;

}

export interface ICommitteeMemberRoleValidateActionCreator {
    (
        formData: Dtos.CommitteeMemberRole
    ): ICommitteeMemberRoleValidateAction;
}

export interface ICommitteeMemberRoleValidateSuccessAction {
    type: "ACTION_COMMITTEEMEMBERROLE_VALIDATE_SUCCESS";
    formData: Dtos.CommitteeMemberRole;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeMemberRoleValidateSuccessActionCreator {
    (
        formData: Dtos.CommitteeMemberRole,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeMemberRoleValidateSuccessAction;
}

export interface ICommitteeMemberRoleValidateFailureAction {
    type: "ACTION_COMMITTEEMEMBERROLE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeMemberRoleValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeMemberRoleValidateFailureAction;
}

export interface ICommitteeMemberRoleClearAction {
    type: "ACTION_COMMITTEEMEMBERROLE_CLEAR";
    propertiesToClear?: string[];
}

export interface ICommitteeMemberRoleClearActionCreator {
    (propertiesToClear?: string[]): ICommitteeMemberRoleClearAction;
}

export interface ICommitteeMemberRoleFilterActionCreator {
    (formFilter: IFormFilter): ICommitteeMemberRoleFilterAction;
}

export interface ICommitteeMemberRoleFilterAction {
    type: "ACTION_COMMITTEEMEMBERROLE_FILTER";
    formFilter: IFormFilter;
}


export type CommitteeMemberRoleAction =
    ICommitteeMemberRoleLoadAction |
    ICommitteeMemberRoleLoadByIdAction |
    ICommitteeMemberRoleLoadByCommitteeIdAction |
    ICommitteeMemberRolesLoadByPersonnelIdAction |
    ICommitteeMemberRoleLoadFailureAction |
    ICommitteeMemberRoleLoadSuccessAction |
    ICommitteeMemberRoleSaveAction |
    ICommitteeMemberRoleSaveSuccessAction |
    ICommitteeMemberRoleSaveFailureAction |
    ICommitteeMemberRoleCreateAction |
    ICommitteeMemberRoleCreateSuccessAction |
    ICommitteeMemberRoleCreateFailureAction |
    ICommitteeMemberRoleValidateAction |
    ICommitteeMemberRoleValidateSuccessAction |
    ICommitteeMemberRoleValidateFailureAction |
    ICommitteeMemberRoleClearAction | 
    ICommitteeMemberRoleFilterAction;
